import { useContext } from 'react';
import { ContextoSessao, type ValorSessao } from './contexto-sessao';

/** Fica em arquivo próprio para o fast refresh não derrubar o provedor. */
export function useSessao(): ValorSessao {
  const contexto = useContext(ContextoSessao);
  if (!contexto) throw new Error('useSessao precisa estar dentro de ProvedorSessao.');
  return contexto;
}
